import { Link } from 'react-router-dom';
export default function Header() { return <header className="site-header"><Link to="/" className="wordmark">Chronicles<span>of Chaos</span></Link></header>; }
